import { Path } from 'react-hook-form'
import { RegisterSchemaType } from 'schemas/register.schema'

export const registerFields: {
  name: Path<RegisterSchemaType>
  label: string
  type: string
  colSpan: number[]
  helper?: string
}[] = [
  {
    colSpan: [6],
    name: 'firstName',
    label: 'Nombre *',
    type: 'text',
  },
  {
    colSpan: [6],
    name: 'lastName',
    label: 'Apellido *',
    type: 'text',
  },
  {
    colSpan: [6],
    name: 'email',
    label: 'Correo Electrónico *',
    type: 'text',
  },
  {
    colSpan: [6],
    name: 'username',
    label: 'Nombre de usuario *',
    type: 'text',
    helper: 'Mínimo 5 caracteres y máximo 10, solo letras y números',
  },
  {
    colSpan: [6],
    name: 'password',
    label: 'Contraseña *',
    type: 'password',
    helper: 'Mínimo 5 caracteres',
  },
]
